/**
 * Centralized Currency Configuration for VisaProofs
 * Exactly 25 supported currencies. Default currency is USD.
 */

export const SUPPORTED_CURRENCIES = [
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'CA$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr' },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'zł' },
  { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč' },
  { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft' },
  { code: 'ILS', name: 'Israeli New Shekel', symbol: '₪' },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'MX$' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  { code: 'TWD', name: 'New Taiwan Dollar', symbol: 'NT$' },
];

export const DEFAULT_CURRENCY = 'USD';

export const SUPPORTED_CURRENCY_CODES = SUPPORTED_CURRENCIES.map((c) => c.code);

/**
 * Get currency details by code (fallback to USD).
 * @param {string} code
 */
export function getCurrencyInfo(code) {
  if (!code || typeof code !== 'string') return SUPPORTED_CURRENCIES[0];
  const formatted = code.trim().toUpperCase();
  return SUPPORTED_CURRENCIES.find((c) => c.code === formatted) || SUPPORTED_CURRENCIES[0];
}

/**
 * Validate whether a currency code is in the 25 supported currencies whitelist.
 * @param {string} code
 * @returns {boolean}
 */
export function isValidCurrency(code) {
  if (!code || typeof code !== 'string') return false;
  const formatted = code.trim().toUpperCase();
  return SUPPORTED_CURRENCY_CODES.includes(formatted);
}
